import { takeEvery } from 'redux-saga/effects'
import { PUSH_EVENT } from './constants'
import Raven from 'raven-js'
import { makePushEvent } from '@devicebits/analytics-client'
import { getPermanentId } from '../../helpers/getPermanentId'
import { getAppInstanceId } from '../../helpers/getAppInstanceId'

const appStartTime = new Date()

const pushEvent = makePushEvent({
  apiUrl: `${process.env.REACT_APP_ANALYTICS_API}/analytics/bot`,
  debounceDelay: 5000,

  baseProps: {
    app_instance_time: () => (
      (new Date() - appStartTime).toString()
    ),
    page: () => ({
      url: window.location.href
    }),
    referrer: () => ({
      url: document.referrer
    }),
    user_agent: navigator.userAgent,
    permanent_id: getPermanentId(),
    botName: () => sessionStorage.getItem('bot_name'),
    botId: () => sessionStorage.getItem('bot_id'),
    user_email: () => localStorage.getItem('user_email'),
    call_session_id: () => sessionStorage.getItem('call_session_id')
  }
})

function worker(action) {
  pushEvent({ category: action.category, data: {...action.payload, ...{app_instance_id: getAppInstanceId()}}})
    .catch(err => {
      Raven.captureException(err)
      console.log('Failed to send events to analytics', err)
    })
}

export default function* watcher() {
  yield takeEvery(PUSH_EVENT, worker)
}



// WEBPACK FOOTER //
// ./src/hocs/TrackingHOC/saga.js